import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CountriesState } from '../reducers/countries';
import { Country } from '../../models/country';

const getCountriesStore =
  createFeatureSelector<CountriesState>('countries');

export const getCountries = createSelector(
  getCountriesStore,
  (state: CountriesState): Country[] => state.countries,
);
export const getSortedCountries = createSelector(
  getCountriesStore,
  (state: CountriesState): Country[] =>
    [...state.countries].sort((_a: Country, _b: Country) => _a.localized.localeCompare(_b.localized)),
);
export const areCountriesLoading = createSelector(
  getCountriesStore,
  (state: CountriesState): boolean => state.isLoading,
);
export const areCountriesLoaded = createSelector(
  getCountriesStore,
  (state: CountriesState): boolean => state.isLoaded,
);
